import React from 'react'

export default (props) => {
    const divHeight = (props.height ? props.height : "348") + "px"
    return (
        <div className="loading-inside-div" style={{ width: "100%", height: divHeight, textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="loading-icon inside-content" style={{

            }}>
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 420.8 417.2" xmlSpace="preserve">
                    <g id="GUIDELINE">
                    </g>
                    <g id="Layer_1_copy">
                        <g>
                            <polygon fill="#db0032" className="st0" points="241.8,177 241.8,0 179,0 179,177 0,177 0,239.7 179,239.7 179,417.2 241.8,417.2 241.8,239.7 420.8,239.7 420.8,177" />
                        </g>
                    </g>
                </svg>
                {/* <img src="https://cdn.thebeautrium.com/web-image/plus.svg" alt="BEAUTRIUM Loading" /> */}
            </div>
        </div>
    )
}